export function track(eventName, payload = {}) {
  const detail = { ...payload };
  window.dataLayer = window.dataLayer || [];
  if (window.dataLayer && typeof window.dataLayer.push === "function") {
    window.dataLayer.push({ event: eventName, ...detail });
  }
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
}
